module.exports = __webpack_public_path__ + "static/media/icons_Torticolis congénital et plagiocéphalie.357eee6c.svg";